import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  /* Import modern fonts - Outfit for headings, Plus Jakarta Sans for body */
  @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap');

  *,
  *::after,
  *::before {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    scroll-behavior: smooth;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body {
    background: ${({ theme }: any) => theme.background};
    color: ${({ theme }: any) => theme.text};
    font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    line-height: 1.6;
    transition: background-color 0.3s ease, color 0.3s ease;
    min-height: 100vh;
    position: relative;
    overflow-x: hidden;
  }

  /* Decorative background pattern */
  body::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${({ theme }: any) => theme.mode === 'light' 
      ? `
        radial-gradient(circle at 20% 20%, rgba(16, 185, 129, 0.08) 0%, transparent 50%),
        radial-gradient(circle at 80% 80%, rgba(13, 148, 136, 0.06) 0%, transparent 50%),
        radial-gradient(circle at 40% 60%, rgba(245, 158, 11, 0.04) 0%, transparent 40%)
      `
      : `
        radial-gradient(circle at 20% 20%, rgba(52, 211, 153, 0.05) 0%, transparent 50%),
        radial-gradient(circle at 80% 80%, rgba(45, 212, 191, 0.03) 0%, transparent 50%),
        radial-gradient(circle at 40% 60%, rgba(251, 191, 36, 0.02) 0%, transparent 40%)
      `
    };
    pointer-events: none;
    z-index: -1;
  }

  /* Headings */
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Outfit', -apple-system, BlinkMacSystemFont, sans-serif;
    font-weight: 600;
    line-height: 1.2;
    letter-spacing: -0.02em;
  }

  /* Links */
  a {
    color: ${({ theme }: any) => theme.link};
    text-decoration: none;
    transition: color 0.2s ease, opacity 0.2s ease;
    
    &:hover {
      opacity: 0.8;
    }
  }

  /* Buttons */
  button {
    font-family: 'Plus Jakarta Sans', -apple-system, BlinkMacSystemFont, sans-serif;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  /* Selection */
  ::selection {
    background: ${({ theme }: any) => theme.primary};
    color: white;
  }

  /* Scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${({ theme }: any) => theme.backgroundMuted};
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }: any) => theme.border};
    border-radius: 4px;
    
    &:hover {
      background: ${({ theme }: any) => theme.textMuted};
    }
  }

  /* Focus styles */
  *:focus-visible {
    outline: 2px solid ${({ theme }: any) => theme.primary};
    outline-offset: 2px;
  }

  /* Prevent iOS zoom on input focus - font-size must be >= 16px */
  input, textarea, select, [role="combobox"] {
    font-size: 16px !important;
  }
  
  /* React Select specific - ensure no zoom */
  [class*="control"] {
    font-size: 16px !important;
  }
  
  [class*="Input"] {
    font-size: 16px !important;
  }

  /* Animations */
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes slideUp {
    from { 
      opacity: 0;
      transform: translateY(20px);
    }
    to { 
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }

  @keyframes shimmer {
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }

  /* Utility classes */
  .glass {
    background: ${({ theme }: any) => theme.backgroundGlass};
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border: 1px solid ${({ theme }: any) => theme.border};
  }

  .gradient-text {
    background: ${({ theme }: any) => theme.gradientPrimary};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
`;
